// extracted by mini-css-extract-plugin
export default {"cattleRanch":"cattle-ranch_cattleRanch__QAUL6","cattleRanchIcon":"cattle-ranch_cattleRanchIcon__+cHqt","copyButton":"cattle-ranch_copyButton__xmPWR"};